import React from 'react';
import { 
  Box,
  constants
 } from '@match/react-component-library';
import {
  BackgroundImage,
  Header
} from '../components';

const { SPACE } = constants

interface PageLayoutProps {
  children: React.ReactNode;
  dark: boolean;
}

export const MobileLayout: React.FC<PageLayoutProps> = ({
  children,
  dark,
}) => {
  return (
    <BackgroundImage dark={dark}>
      <Box
        alignItems="center"
        display="flex"
        flexDirection="column"
        justifyContent="start"
        minHeight="100%"
        width="100%"
        overflowY="auto"
      >
        <Header desktop={false} dark={!dark} />
        <Box
          alignItems="left"
          display="flex"
          flex="1"
          flexDirection="column"
          justifyContent="center"
          width="100%"
          maxWidth="372"
          padding={SPACE.LARGE}
        >
          {children}
        </Box>
      </Box>
    </BackgroundImage>
  );
};
